.ea{white-space:nowrap;}